// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__5tgQc","copyright":"Footer_copyright__Z0wWE"};